module.exports = __webpack_public_path__ + "static/media/test3_3.669fb8b2.png";